/* eslint-disable class-methods-use-this */
/* eslint-disable react/jsx-fragments */
import React from "react";

import Icon from "../components/icon/icon";
import FooterLinks from "../components/footerLinks/footerLinks";
import Floater from "../components/floater/floater";
import { isFunction, gatherClasses } from "./utils";

const SIDEBAR_TOGGLE_ICON = (
  <svg
    version="1.1"
    className="oui-expanded oui-toggle-icon"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="12px"
    height="12px"
    viewBox="0 0 451.846 451.847"
  >
    <g>
      <path
        d="M345.441,248.292L151.154,442.573c-12.359,12.365-32.397,12.365-44.75,0c-12.354-12.354-12.354-32.391,0-44.744
          L278.318,225.92L106.409,54.017c-12.354-12.359-12.354-32.394,0-44.748c12.354-12.359,32.391-12.359,44.75,0l194.287,194.284
          c6.177,6.18,9.262,14.271,9.262,22.366C354.708,234.018,351.617,242.115,345.441,248.292z"
      />
    </g>
  </svg>
);

const SIDEBAR_PIN_ICON = (
  <svg
    id="Layer_2"
    className="oui-pin"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="12px"
    height="12px"
    viewBox="0 0 34.12 34.12"
  >
    <path
      d="M583.08,882.79l-9.9-9.9a1,1,0,0,0-1.41,0l-1.41,1.41a1,1,0,0,0,0,1.41l0.71,0.71-11.31,11.31-2.12-2.12a1,1,0,0,0-1.41,0L554.8,887a1,1,0,0,0,0,1.41l12.73,12.73a1,1,0,0,0,1.41,0l1.41-1.41a1,1,0,0,0,0-1.41l-2.12-2.12,11.31-11.31,0.71,0.71a1,1,0,0,0,1.41,0l1.41-1.41A1,1,0,0,0,583.08,882.79Z"
      transform="translate(-549.25 -872.6)"
    />
    <path
      d="M549.84,903.31a2,2,0,0,0,2.83,2.83l10.62-9.2L559,892.7Z"
      transform="translate(-549.25 -872.6)"
    />
  </svg>
);

export default class SidebarUtils {
  constructor(context) {
    this.context = context;
  }

  isSectionDivider(section) {
    const { divider, component } = section;
    if (!!divider && !!component) {
      throw new Error(
        "<Sidebar />: Both divider and component cannot be passed together in a sidebar section"
      );
    }
    return divider === true;
  }

  renderFloatingSidebar = props => {
    const { dellDoubleHeader } = this.context || {};

    return (
      <Floater
        position={props.float.direction}
        show={props.float.visible}
        overlay
        onOverlayClick={props.float.toggle}
        onShow={props.onExpand}
        onHide={props.onCollapse}
      >
        <div
          data-testid={props.dataTestId}
          className={gatherClasses(
            props,
            "oui-sidebar-container",
            dellDoubleHeader && "oui-double-header-support",
            "oui-sidebar-floating"
          )}
        >
          {props.float.direction === "left" && (
            <div className="oui-position-relative">
              <div className="oui-separator-line" />
            </div>
          )}
          {this.renderSections(props.sections, true)}
          {this.renderSidebarFooter(props.footerLinks)}
        </div>
      </Floater>
    );
  };

  renderStaticSidebar = (
    props,
    isCollapsed = false,
    isHoverable = false,
    toggle = () => {},
    isTabletView,
    innerRef
  ) => {
    const { dellDoubleHeader } = this.context || {};
    return (
      <React.Fragment>
        <div
          ref={innerRef}
          data-testid={props.dataTestId}
          className={gatherClasses(
            props,
            "oui-sidebar-container",
            dellDoubleHeader && "oui-double-header-support",
            "oui-sidebar-static",
            props.collapsible && isCollapsed ? "oui-sidebar-collapsed" : null,
            props.collapsible && isHoverable ? "oui-sidebar-hoverable" : null,
            props.honourGlobalFooter
              ? "oui-sidebar-honour-global-footer"
              : null,
            props.honourPageAlert ? "oui-sidebar-honour-page-alert" : null
          )}
        >
          {!isTabletView &&
            props.collapsible &&
            isCollapsed &&
            isHoverable &&
            this.renderCollapseToggler(toggle, isCollapsed, true)}
          {this.renderSidebarHeading(props)}
          {props.site && this.renderSite(props.site)}
          {this.renderSections(props.sections, false)}
        </div>
        {<div className="oui-sidebar-placeholder" />}
        {!isTabletView &&
          props.collapsible &&
          !isCollapsed &&
          !isHoverable &&
          this.renderCollapseToggler(toggle, isCollapsed, false)}
      </React.Fragment>
    );
  };

  renderCollapseToggler = (toggle, isCollapsed, isPositionedFixed) => {
    return (
      <div
        className={gatherClasses(
          null,
          isPositionedFixed
            ? "oui-collapse-toggler-static"
            : "oui-collapse-toggler-fixed",
          "oui-collapse-toggler"
        )}
        onClick={toggle}
        aria-hidden="true"
      >
        <Icon svg={isCollapsed ? SIDEBAR_PIN_ICON : SIDEBAR_TOGGLE_ICON} />
      </div>
    );
  };

  renderSidebarHeading = props => {
    const { sidebarName } = props;
    if (this.context && this.context.isDellApplication() && sidebarName) {
      return (
        <div className="oui-sidebar-heading">
          <div className="oui-sidebar-heading-text">
            <hr
              className="oui-sidebar-heading-separator-line"
              data-content={sidebarName}
            />
          </div>
        </div>
      );
    }

    return null;
  };

  renderSidebarFooter = links => {
    if (this.context && this.context.isDellApplication()) {
      return (
        links &&
        links.length > 0 && (
          <div className="oui-floating-sidebar-footer-container">
            <FooterLinks inSidebar links={links} />
          </div>
        )
      );
    }

    return null;
  };

  renderSite = site => {
    return (
      <div className="oui-site-container">
        <div className="oui-site-icon-container">
          {site.icon ? (
            React.isValidElement(site.icon) ? (
              React.cloneElement(site.icon, {
                className: gatherClasses(
                  null,
                  "oui-site-icon",
                  site.icon.props.className
                ),
                size: "md",
                width: 16,
                height: 16,
                muted: false
              })
            ) : (
              <Icon
                {...site.icon}
                width="16px"
                height="16px"
                muted={false}
                className={gatherClasses(site.icon, "oui-site-icon")}
              />
            )
          ) : null}
        </div>
        {site.name ? (
          <div className="oui-site-name">
            <div>{site.name}</div>
            {site.subtitle && (
              <div className="oui-site-subtitle">{site.subtitle}</div>
            )}
          </div>
        ) : null}
      </div>
    );
  };

  renderSingleSection(section) {
    return (
      <React.Fragment>
        {section.heading && (
          <div className="oui-section-heading oui-h6 oui-text-truncate">
            {section.heading}
          </div>
        )}
        {isFunction(section.component) && (
          <div
            className={gatherClasses(section, "oui-sidebar-section-component")}
          >
            {section.component()}
          </div>
        )}
      </React.Fragment>
    );
  }

  renderSectionDivider() {
    return <hr className="oui-sidebar-section-divider" />;
  }

  renderSections = (sections, isFloating = false) => {
    return (
      <div
        className={gatherClasses(
          null,
          "oui-sidebar-sections",
          isFloating ? "oui-invert-scroll" : null
        )}
      >
        {sections.map((section, index) => {
          const isDivider = this.isSectionDivider(section);
          return (
            <div
              className={gatherClasses(null, "oui-sidebar-section")}
              key={`sidebar-section-${index}`}
            >
              {!isDivider
                ? this.renderSingleSection(section)
                : this.renderSectionDivider()}
            </div>
          );
        })}
      </div>
    );
  };
}
